<script>
export default {
  name: 'ProfileManage',
  data() {
    return {
      item: {
        profile: {
          email: null,
        },
      },
    }
  },
  computed: {
    getProfile() {
      return {
        'E-mail': this.item.profile.email,
        Имя: this.item.profile.first_name,
        Фамилия: this.item.profile.last_name,
        Отчество: this.item.profile.middle_name,
        Регион: this.item.profile.region,
        Компания: this.item.profile.company,
        Телефон: this.item.profile.telephone,
      }
    },
  },
  methods: {
    fetchProfile() {
      axios.get('/webapi/profile').then(({data}) => {
        this.item.profile = data.data
      })
    },
  },
  created() {
    this.fetchProfile()
  },
}
</script>
